module.exports = __webpack_public_path__ + "img/logo-img.81e51b19.svg";